import { render, staticRenderFns } from "./UploadData.vue?vue&type=template&id=1ecda8d4&"
import script from "./UploadData.vue?vue&type=script&lang=js&"
export * from "./UploadData.vue?vue&type=script&lang=js&"
import style0 from "./UploadData.vue?vue&type=style&index=0&id=1ecda8d4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports